import { SmartDmMeasurementParser } from './SmartDmMeasurementParser';
import type { ParsedData } from '../../../../interfaces/toolData';

/**
 * Parser for JAE Smart DM VOLTAGES files
 * 
 * Handles power system measurements including:
 * - Battery voltages (BAT1V, BAT2V)
 * - Bus voltages (BUS, 5V0, 3V3, 1V8)
 * - Supply voltages (P13V, N13V)
 * - System current (SYS_CURRENT)
 */
export class SmartDmVoltagesParser {
  static parse(fileContent: string): ParsedData {
    const unitMappings = {
      'BAT1V': 'V',
      'BAT2V': 'V', 
      'BUS': 'V',
      '5V0': 'V',
      '3V3': 'V',
      '1V8': 'V',
      'P13V': 'V',
      'N13V': 'V',
      'SYS_CURRENT': 'A'
    };
    
    return SmartDmMeasurementParser.parse(
      fileContent,
      'VOLTAGES',
      'JAE_SMARTDM_VOLTAGES',
      unitMappings
    );
  }
} 